import Component from "@glimmer/component"

export default class GoogleClassroomDocumentSharingMenuComponent extends Component {}
